var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showFullScreenBtn)?_c('div',{staticClass:"full-screen-btn-con",on:{"click":_vm.handleChange}},[_c('Tooltip',{attrs:{"content":_vm.value ? '退出全屏' : '全屏',"placement":"bottom"}},[_c('Icon',{attrs:{"type":_vm.value ? 'ios-contract' : 'ios-expand',"size":24}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }